/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Ai_LabelInputs */

const en_fc_cmp_ai_label = /** @type {(inputs: Fc_Cmp_Ai_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI features`)
};

/**
* | output |
* | --- |
* | "AI features" |
*
* @param {Fc_Cmp_Ai_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_ai_label = /** @type {((inputs?: Fc_Cmp_Ai_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Ai_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_ai_label(inputs)
});
export { fc_cmp_ai_label as "fc.cmp.ai.label" }